import { clearExperienceById, fetchExperienceById } from 'actions/ExperienceActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useRef } from 'react'

interface Options {
  disabled?: boolean
}

function useExperience(
  experienceId: string = '',
  options: Options = {},
): [App.ExperienceOffer | undefined, boolean, any] {
  const dispatch = useAppDispatch()
  const locale = useAppSelector(state => state.geo.locale)
  const prevLocaleRef = useRef(locale)

  useEffect(() => {
    if (!experienceId) return
    // Clear stale-locale data even when the hook is disabled, so a later
    // re-enable doesn't serve old-locale data hidden behind the dedup guard.
    const localeChanged = prevLocaleRef.current !== locale
    if (localeChanged) {
      dispatch(clearExperienceById(experienceId))
      prevLocaleRef.current = locale
    }
    if (!options.disabled) {
      dispatch(fetchExperienceById(experienceId))
    }
  }, [experienceId, options.disabled, dispatch, locale])

  const experience = useAppSelector(state => state.experience.experiences[experienceId])
  const fetching = useAppSelector(state => state.experience.fetchingExperiences[experienceId])
  const error = useAppSelector(state => state.experience.experienceErrors[experienceId])

  return [experience, fetching, error]
}

export default useExperience
